import styled from 'styled-components';
import {
  Loader as LoaderLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;

export const Title = styled.h1`
  font-size: 48px;
  font-weight: 500;
  margin-top: 30px;
`;

export const Video = styled.video`
  display: none;
`;

export const Loader = styled(LoaderLayoutComponent)``;
